import { render } from "./TapForService.vue?vue&type=template&id=d2ddbc98&scoped=true"
const script = {}

import "./TapForService.vue?vue&type=style&index=0&id=d2ddbc98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2ddbc98"]])

export default __exports__